import React, { useCallback, useEffect } from 'react';
import qs from 'qs-lite';
import { withRouter } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';

import { VpSelect } from '../../inputs';
import { getPageCount, getCurrentPage } from '../../../utils';
import { getQueryParamMap } from '../../../utils';

// styles
const containerStyles = {
  backgroundColor: 'vpColors.white',
  padding: '8px 20px',
  border: 1,
  borderColor: 'vpColors.greyLight',
  borderRadius: '5px',
  mt: '10px'
};

const LIMIT_OPTIONS = [25, 50, 75, 100];

export const VpTablePagination = withRouter(({ history, data, onChange }) => {
  const meta = data?.meta || {};

  useEffect(() => {
    const pageLimit = (getCurrentPage(meta) - 1) * meta?.limit;
    if (pageLimit > meta?.count) {
      updateQueryString({ offset: 0 });
    }
  }, [meta?.count]);

  const updateQueryString = useCallback((newQueryParams) => {
    onChange && onChange();
    const queryParamMap = {
      ...getQueryParamMap(history),
      ...newQueryParams
    };
    const searchString = `?${qs.stringify(queryParamMap)}`;
    history?.push(
      {
        pathname: history?.location?.pathname,
        search: searchString
      },
      { from: 'PAGINATION_CHANGE' }
    );
  }, []);

  const onLimitChange = ({ target }) => {
    updateQueryString({ limit: target?.value, offset: 0 });
  };
  const onPageChange = (e, page) => {
    updateQueryString({ offset: (page - 1) * meta?.limit });
  };

  return (
    <Stack sx={containerStyles} direction="row" alignItems="center" justifyContent="space-between">
      <Stack
        divider={<Divider orientation="vertical" flexItem />}
        direction="row"
        spacing={2}
        alignItems="center"
      >
        <VpSelect
          size="small"
          options={LIMIT_OPTIONS}
          value={meta?.limit || 25}
          onChange={onLimitChange}
        />
        <Typography>{meta?.count} Results</Typography>
      </Stack>
      <Pagination
        onChange={onPageChange}
        page={getCurrentPage(meta)}
        count={getPageCount(meta)}
        shape="rounded"
        color="primary"
      />
    </Stack>
  );
});

export default VpTablePagination;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpTablePagination/VpTablePagination.jsx